import {Fetch} from "./Fetch";

export class CalculatorAPI {
    static async getQuestions(){
        let data = await Fetch('GET','api/calculator/questions');
        return data.groups;
    }

    static async submitAnswers(data){
        let resp = await Fetch('POST', 'api/calculator/evaluate_answers', data);
        return resp;
    }
}
